import React from "react";
import WithMyAcademics from "components/data/WithMyAcademics";
import WithSemesters from "components/data/WithSemesters";
import { useRoles } from "components/hooks/useRoles";

import { InstructorAcademicsPage } from "./InstructorAcademicsPage";
import { StudentAcademicsPage } from "./StudentAcademicsPage";

// https://wikihub.berkeley.edu/display/SIS/CalCentral+My+Academics+Page
export function AcademicsPage() {
  const { student, faculty } = useRoles();
  const isInstructor = faculty && !student;

  return (
    <WithMyAcademics>
      <WithSemesters>
        {isInstructor ? <InstructorAcademicsPage /> : <StudentAcademicsPage />}
      </WithSemesters>
    </WithMyAcademics>
  );
}
